export default {
  actions: {
    create: 'Create new Client',
    add: 'Add',
    add_item: 'Add Item',
    add_button: 'Add button',
    add_phone_number: 'Add WhatsApp Number',
    remove: 'Remove',
    enable_interactive: 'Enable Interactive Mode',
    disable_interactive: 'Disable Interactive Mode',
    share_location: '📍 Share your location',
    chat: 'Chat',
  },
  tabs: {
    connections: 'Connections',
  },
  status: {
    awaiting_scan: 'Waiting for scan',
    generating_code: 'Generating code…',
    syncing: 'Syncing…',
  },
  fields: {
    id: 'Phone',
    alias: 'Alias',
    buttons: 'Buttons',
    button: 'Button',
    button_text: 'Button Text',
    list: 'List',
    list_items: 'List Items',
    location_request: 'Location Request',
    characters: 'chars',
    reply_buttons_label: 'Reply buttons',
    column_label: 'Label',
    column_action_id: 'Action / ID',
  },
  placeholders: {
    delete: 'The client will be removed, do ypu want to continue?',
    default: 'Default client to confirmations',
    select_default: 'Select default',
    select_wp_api: 'Connect to Whatsapp API',
    restart: 'The client will be restarted, do you want to continue?',
    message_type: 'Select message type',
    button_text: 'Enter button text',
    button_label: 'Visible text',
    button_action: 'ACTION',
    item_id: 'Item ID',
    item_title: 'Item Title',
    item_description: 'Item Description (optional)',
    editor_message: 'Write your message… use *bold* or _italic_',
    scan_hint: 'Scan with WhatsApp → Linked devices',
    default_badge: 'Default',
  },
  validations: {
    button_text_max_length: 'Button text must be 20 characters or less',
    button_title_max_length: 'Button titles must be 20 characters or less',
    list_items_max_length: 'Item titles max 24 chars, descriptions max 72 chars',
  },
  titles: {
    confirmations_messages: 'Confirmations Messages',
    chatbot_messages: 'Chatbot Messages',
    interactive_message: 'Edit Interactive Message',
  },
  preview: {
    business_name: 'Gorda Taxi',
    online: 'online',
    empty_hint: 'Write a message to see the preview',
  },
  modal: {
    title: 'Edit WhatsApp Message',
    subtitle: 'Template',
    save: 'Save',
    interactive_enabled_title: 'Interactive mode enabled',
    interactive_disabled_title: 'Interactive mode disabled',
    interactive_enabled_hint: 'The message includes quick-reply buttons',
    interactive_disabled_hint: 'Enable to add quick-reply buttons',
    footer_hint: 'Changes are applied on save',
  },
  errors: {
    facebook_sdk_not_loaded: 'Facebook SDK has not loaded correctly',
    failed_to_connect_phone: 'Failed to connect phone number',
  },
  success: {
    phone_number_connected: 'Phone number connected successfully',
  },
  info: {
    signup_cancelled: 'Signup process cancelled',
    processing: 'Processing...',
    connecting_phone_number: 'Connecting phone number, please wait',
  }
}